import { property, remote, supertypeClass } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { Application } from '../../common/js/customer/Application';
import { AgentProxy } from '../../common/js/agent/AgentProxy';
import { OpsProxy } from '../../common/js/agent/OpsProxy';
import { Entitlement } from '../../common/js/agent/UserPrincipal';
import { Agent } from '../../common/js/customer/Agent';
import { OriginatorActions } from '../js/interfaces/CoverpathTypes';

//this is the class link between application and proxy, agent will not saved in this
//only for ops-proxy and agent-proxy for now
@supertypeClass({ toClient: true, toServer: true })
export class ApplicationOriginator extends Everything {
  @property({ getType: () => Application })
  application: Application;

  @property()
  originatorType: Entitlement;

  @property()
  originatorId: string;

  @property({ comment: 'what has been done by this originator' })
  action: OriginatorActions = OriginatorActions.CREATE_APPLICATION;

  constructor() {
    super();
  }

  static new(application: Application) {
    return new ApplicationOriginator().init(application);
  }

  init(application: Application) {
    this.application = application;
    return this;
  }

  setApplicationOriginator(user: Agent | AgentProxy | OpsProxy, entitlement: Entitlement) {
    this.originatorId = user._id;
    this.originatorType = entitlement;
  }

  // Needed when cloning the applicationOriginator
  setApplicationOriginatorId(userId: string, role: Entitlement) {
    this.originatorId = userId;
    this.originatorType = role;
  }

  @remote({ on: 'server' })
  async getAgentProxy(): Promise<AgentProxy | OpsProxy | Agent> {
    switch (this.originatorType) {
      case Entitlement.AGENT_PROXY: {
        return AgentProxy.persistorFetchById(this.originatorId, { session: this.amorphic });
      }
      case Entitlement.OPS_PROXY: {
        return OpsProxy.persistorFetchById(this.originatorId, { session: this.amorphic });
      }
      case Entitlement.DUAL_ROLE: {
        return this.originatorId ? Agent.persistorFetchById(this.originatorId, { session: this.amorphic }) : null;
      }
      default:
        return null;
    }
  }

  @remote({ on: 'server' })
  async getUserById(): Promise<AgentProxy | OpsProxy | Agent> {
    switch (this.originatorType) {
      case Entitlement.AGENT_PROXY: {
        return AgentProxy.persistorFetchById(this.originatorId, { session: this.amorphic });
      }
      case Entitlement.OPS_PROXY: {
        return OpsProxy.persistorFetchById(this.originatorId, { session: this.amorphic });
      }
      case Entitlement.AGENT:
      case Entitlement.DUAL_ROLE: {
        return this.originatorId ? Agent.persistorFetchById(this.originatorId, { session: this.amorphic }) : null;
      }
      default:
        return null;
    }
  }
}
